<template>
  <div class="enter-package flexbox vertical">
    <header class="page-header flexbox space-bt">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('EnterPackage.rwdw6u') }}</span>
      <van-icon name="ellipsis" class="text-white" />
    </header>
    <main class="flex-fill page-body">
      <div class="form round">
        <van-field
          :label="$t('快递单号')"
          required
          v-model="orderNo"
        ></van-field>
        <van-field :label="$t('物品名称')" v-model="name"></van-field>
        <van-field :label="$t('数量')" v-model="qty"></van-field>
        <van-field :label="$t('件数')" v-model="pcs"></van-field>
        <van-field :label="$t('申报货值')" v-model="declarePrice"></van-field>
        <!-- <van-field :label="$t('进仓号')" v-model="inStoreNumber"></van-field> -->
        <van-field :label="$t('国家')" v-model="destCountry"></van-field>
        <van-field :label="$t('电话')" v-model="tel"></van-field>
        <van-field :label="$t('备注')" v-model="note"></van-field>
      </div>
      <!-- 添加仓库选择器 -->
      <van-field :label="$t('选择仓库')">
        <template #input>
          <el-select
            v-model="selectedWarehouseId"
            :placeholder="$t('选择仓库')"
            @change="onWarehouseChange"
            style="width: 100%"
            size="small"
          >
            <el-option
              v-for="warehouse in warehouseList"
              :key="warehouse.PK_ID"
              :label="warehouse.sName"
              :value="warehouse.PK_ID"
            >
            </el-option>
          </el-select>
        </template>
      </van-field>
      <!-- 在现有申报货值字段后添加 -->
      <div class="warehouse-tip">
        <van-icon name="warning-o" class="warning-icon" />
        <span>{{ $t('请选择正确的仓库，选错仓库可能导致货物丢失') }}</span>
      </div>
      <div class="note">
        {{ $t('EnterPackage.aaexyg') }}
      </div>
      <div class="x-center">
        <van-button type="info" @click="onSubmit">{{
          $t('EnterPackage.52vibt')
        }}</van-button>
      </div>
      <div class="address round">
        <van-collapse v-model="activeName" accordion @change="onCollapseChange">
          <van-collapse-item
            v-for="warehouse in warehouseList"
            :key="warehouse.PK_ID"
            :title="warehouse.sName"
            :name="warehouse.PK_ID"
          >
            <div>
              {{ $t('EnterPackage.5jllo7') }}
              {{ warehouse.sContactor }}
              #{{ userInfo != null ? userInfo.sCustNo : '' }}
            </div>
            <div>
              {{ $t('EnterPackage.bzs54i') }}{{ warehouse.sContactTel }}
            </div>
            <div>{{ $t('EnterPackage.f4o25k') }}{{ warehouse.sZipCode }}</div>
            <div>
              {{ $t('EnterPackage.uc0c1f') }}
              {{ getAddress(warehouse) }}
              #{{ userInfo != null ? userInfo.sCustNo : '' }}
            </div>
            <div>{{ $t('EnterPackage.8qeqyj') }}{{ warehouse.sDesc }}</div>
          </van-collapse-item>
        </van-collapse>
        <div class="x-center">
          <van-button
            type="info"
            id="copy"
            :data-clipboard-text="output"
            @click="copy"
            >{{ $t('一键复制') }}
          </van-button>
        </div>
        <div class="indent">
          <div>{{ $t('EnterPackage.sb9f6s') }} {{ stock_rec_worktime }}</div>
          <div>{{ $t('EnterPackage.o6hjut') }}</div>
        </div>
        <div class="tip">
          {{ $t('EnterPackage.fljdjs') }}
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { $t } from '@/plugins/i18n';
import Clipboard from 'clipboard';
import { addPackage, getStockInfo, getStoreList } from '@/api/deliver.js';
import Vue from 'vue';
import { Collapse, CollapseItem } from 'vant';
import { Select, Option } from 'element-ui';
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Select);
Vue.use(Option);
export default {
  data() {
    return {
      activeName: null,
      warehouseList: [],
      output: '',
      orderNo: '',
      name: '',
      note: '',
      pcs: 0,
      qty: 0,
      inStoreNumber: '',
      destCountry: '',
      tel: '',
      declarePrice: 0,
      stock_name: '',
      stock_rec_name: '',
      stock_rec_tel: '',
      stock_rec_zipcode: '',
      stock_rec_addr: '',
      stock_rec_remark: '',
      stock_rec_worktime: '',
      // 仓库选择相关
      selectedWarehouseId: null,
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    // 获取选中的仓库对象
    selectedWarehouse() {
      return (
        this.warehouseList.find(
          item => item.PK_ID === this.selectedWarehouseId
        ) || null
      );
    },
  },
  methods: {
    // 新增折叠面板变化处理方法
    onCollapseChange(active) {
      if (active) {
        const activeWarehouse = this.warehouseList.find(
          warehouse => warehouse.PK_ID === active
        );
        if (activeWarehouse) {
          this.output = this.formatWarehouseInfo(activeWarehouse);
        }
      }
    },
    // 新增格式化仓库信息的方法
    formatWarehouseInfo(warehouse) {
      if (!warehouse) return '';

      const address = this.getAddress(warehouse);
      const userInfoPart = this.userInfo ? `#${this.userInfo.sCustNo}` : '';

      return (
        `${this.$t('EnterPackage.5jllo7')}${warehouse.sContactor}${userInfoPart}\n` +
        `${this.$t('EnterPackage.bzs54i')}${warehouse.sContactTel}\n` +
        `${this.$t('EnterPackage.f4o25k')}${warehouse.sZipCode}\n` +
        `${this.$t('EnterPackage.uc0c1f')}${address}${userInfoPart}\n` +
        `${this.$t('EnterPackage.8qeqyj')}${warehouse.sDesc}`
      );
    },
    getAddress(warehouse) {
      // 拼接地址信息: 国家 省 市 区 详细地址
      const { sCountryName, sProvince, sCity, sArea, sAddr } = warehouse;
      let address = '';

      if (sCountryName) address += sCountryName;
      if (sProvince) address += sProvince;
      if (sCity && sCity !== sProvince) address += sCity; // 避免重复显示（如广东省广州市）
      if (sArea) address += sArea;
      if (sAddr) address += sAddr;

      return address;
    },
    // 仓库选择变化
    onWarehouseChange(value) {
      // 展开选中的仓库项
      this.activeName = value;
      // 更新 output 内容
      const selectedWarehouse = this.warehouseList.find(
        item => item.PK_ID === value
      );
      if (selectedWarehouse) {
        this.output = this.formatWarehouseInfo(selectedWarehouse);
      }
    },

    loadData() {
      getStockInfo().then(res => {
        if (res.Result == true) {
          var stockInfo = res.DataDict['data'];
          this.stock_name = stockInfo.name;
          this.stock_rec_name = stockInfo.recv;
          this.stock_rec_tel = stockInfo.tel;
          this.stock_rec_zipcode = stockInfo.code;
          this.stock_rec_addr = stockInfo.addr;
          this.stock_rec_remark = stockInfo.note;
          this.stock_rec_worktime = stockInfo.worktime;
        }
      });
      getStoreList().then(res => {
        if (res.Result == true) {
          this.warehouseList = res.DataDict['list'];

          // 设置默认选中第一个仓库
          if (this.warehouseList.length > 0) {
            this.selectedWarehouseId = this.warehouseList[0].PK_ID;
            // 默认展开第一个仓库
            this.activeName = this.selectedWarehouseId;
            // 初始化 output 内容
            this.output = this.formatWarehouseInfo(this.warehouseList[0]);
          }
        }
      });
    },
    reset() {
      this.orderNo = '';
      this.name = '';
      this.note = '';
      this.declarePrice = 0;
      this.bags = 0;
      this.pcs = 0;
      this.shipmark = '';
      this.tel = '';
    },
    onSubmit() {
      addPackage({
        name: this.name,
        deliveryNo: this.orderNo,
        remarks: this.note,
        declarePrice: this.declarePrice,
        storeID: this.selectedWarehouseId,
        bags: this.qty,
        pcs: this.pcs,
        shipmark: this.destCountry,
        tel: this.tel,
      }).then(res => {
        if (res.Result) {
          this.$toast(res.Info);
          this.reset();
        } else {
          this.$toast.fail(res.Info);
        }
      });
    },
    copy() {
      let _this = this;
      let clipborad = new Clipboard('#copy');
      //复制成功
      clipborad.on('success', function() {
        _this.$toast.success($t('复制成功！'));
        clipborad.destory();
      });
      //复制失败
      clipborad.on('error', function() {
        _this.$toast.fail($t('复制失败！'));
        clipborad.destory();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.page-body {
  padding: rem(20px);
}
.round {
  border-radius: rem(10px);
}
.note {
  color: #b8b8b8;
  font-size: 12px;
  line-height: 1.5;
  margin: rem(20px) 0;
}
.van-button {
  height: rem(80px);
  width: rem(500px);
  background-color: $theme-color;
  border: none;
  border-radius: rem(25px);
}
.x-center {
  margin: rem(40px) 0;
}
.address {
  background: rgba(#9c9bb4, 0.3);
  padding: rem(20px);
  padding-bottom: rem(40px);
}

.indent {
  margin-left: rem(40px);
  line-height: 2;
}
.tip {
  padding: rem(32px);
  background: #f6f6f6;
  border-radius: rem(10px);
}
.text-white {
  color: #fff;
}
.warehouse-tip {
  background-color: #fff7e6;
  border: 1px solid #ffe58f;
  border-radius: rem(10px);
  padding: rem(15px);
  margin: rem(15px) 0;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #faad14;

  .warning-icon {
    margin-right: rem(10px);
    font-size: 16px;
  }
}
</style>
